import { useFiltersV2Select } from "PFApp/components/filters_v2";
import {
  generateApiFilters,
  GenerateApiFiltersOptions
} from "PFApp/components/filters_v2/helpers/generate_api_filters";
import { hasAnyFilterToSendInApiCall } from "PFApp/components/filters_v2/helpers/has_any_filter_to_send_in_api_call";
import { useFiltersDataForApiCall } from "PFApp/components/filters_v2/hooks/use_filters_data_for_api_call";
import { useLastUsedFilters } from "PFApp/components/filters_v2/hooks/use_last_used_filters";
import { useMemo } from "react";

export const useApiFilters = ({
  sendDefaultsAsUndefined,
  sendEmptyAsUndefined
}: GenerateApiFiltersOptions = {}) => {
  const { persistent } = useFiltersV2Select("persistent");

  const { isError: cannotLoadLastUsedFilters } = useLastUsedFilters();

  const filtersToUseInApiCall = useFiltersDataForApiCall();

  const apiFilters = useMemo(
    () =>
      filtersToUseInApiCall &&
      generateApiFilters(filtersToUseInApiCall, { sendDefaultsAsUndefined, sendEmptyAsUndefined }),
    [filtersToUseInApiCall, sendDefaultsAsUndefined, sendEmptyAsUndefined]
  );

  return {
    filtersToUseInApiCall,
    apiFilters,
    areApiFiltersReady: filtersToUseInApiCall !== undefined || !persistent || cannotLoadLastUsedFilters,
    hasAnyFilterToSend: hasAnyFilterToSendInApiCall(filtersToUseInApiCall)
  };
};
